module.exports = __webpack_public_path__ + "img/icon_communicate.6486a0d2.png";